/* eslint-disable import/no-extraneous-dependencies */
import { withStyles } from '@mui/styles';

import muiStyles from './styles';
import { WithdrawalWalletMappingForm } from './WithdrawalWalletMappingForm';

export default withStyles(muiStyles)(WithdrawalWalletMappingForm);